import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/timer-reset.vue
var o = {
	name: "DtIconTimerReset",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--timer-reset"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Timer Reset",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M4.5 1A.5.5 0 0 1 5 .5h2a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5ZM6 4.5a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z",
		fill: "currentColor"
	}, null, -1), r("path", {
		d: "M5.996 3.5a3.5 3.5 0 0 0-3.5 3.062.5.5 0 0 1-.992-.124A4.5 4.5 0 0 1 6.002 2.5a4.5 4.5 0 1 1-2.983 7.875l-.001-.001-.518-.46v1.385a.5.5 0 1 1-1 0v-2.5a.5.5 0 0 1 .5-.5h2.5a.5.5 0 0 1 0 1H3.314l.367.326a3.504 3.504 0 0 0 4.638-.008A3.5 3.5 0 0 0 6 3.5h-.003Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=timer-reset.js.map